module.exports = __webpack_public_path__ + "img/jzzx123.36b2f243.png";